import { DealMilestone } from "@/components/shared/DealMilestone";

type milestoneColorKey = "border" | "background" | "dim" | "tag";

const milestoneTokenNames: Record<DealMilestone, string> = {
  [DealMilestone.QUALIFICATION]: "qualification",
  [DealMilestone.PPP]: "ppp",
  [DealMilestone.TECHNICAL_EVALUATION]: "technical-evaluation",
  [DealMilestone.EXECUTIVE_SIGNOFF]: "executive-signoff",
  [DealMilestone.PROCUREMENT]: "procurement"
};

const milestoneOrder = [
  DealMilestone.QUALIFICATION,
  DealMilestone.PPP,
  DealMilestone.TECHNICAL_EVALUATION,
  DealMilestone.EXECUTIVE_SIGNOFF,
  DealMilestone.PROCUREMENT
];

const resolvedTokens = new Map<string, string>();

// Charts and string building need a concrete color, so the token is read resolved.
// Cached for the page: the tokens live only in :root and don't change with the theme.
const resolveToken = (token: string): string => {
  const cached = resolvedTokens.get(token);
  if (cached) return cached;
  const value =
    typeof document === "undefined"
      ? ""
      : getComputedStyle(document.documentElement)
          .getPropertyValue(token)
          .trim();
  if (!value) return `var(${token})`;
  resolvedTokens.set(token, value);
  return value;
};

//emrald : strong-500, soft-900

export const getColorForMilestoneByType = (
  milestone: DealMilestone | undefined,
  colorType: milestoneColorKey = "border"
) => {
  const defaultColor = {
    background: "var(--tertiary)",
    border: "black",
    dim: "var(--tertiary)",
    tag: "var(--tertiary)"
  };
  const name = milestone ? milestoneTokenNames[milestone] : undefined;
  if (name) {
    return resolveToken(`--milestone-${name}-${colorType}`);
  }
  return defaultColor[colorType];
};

export const getBorderColorForMilestone = (
  milestone: DealMilestone | undefined
): string => {
  return getColorForMilestoneByType(milestone, "border");
};

export const getTagColorForMilestone = (
  milestone: DealMilestone | undefined
): string => {
  return getColorForMilestoneByType(milestone, "tag");
};

export const getMilestoneBorderColors = (): string[] =>
  milestoneOrder.map((milestone) =>
    getColorForMilestoneByType(milestone, "border")
  );

export const getMilestoneTagColors = (): string[] =>
  milestoneOrder.map((milestone) =>
    getColorForMilestoneByType(milestone, "tag")
  );
